import axios from "../api/axios"
import { axiosPrivate } from "../api/axios"

const LOGIN_URL= 'auth/login'
const REGISTER_URL= 'auth/register'
const RECOVER_URL= 'auth/forgotpassword'
const RESET_URL= 'auth/resetpassword'
const REFRESH_URL= 'auth/jwt'

const register = async ({data, rol, avatar }) => {
    try {
        const response = await axios
            .post(REGISTER_URL,
                { ...data, rol, avatar },
                { headers: { 'Content-Type': 'application/json' } }
            );
        return response?.data.success;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
};

const login = async (data) => {
    try {
        const response = await axios
            .post(LOGIN_URL,
                data,
                { headers: { 'Content-Type': 'application/json' } }
            );
        return response?.data?.accessToken;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
};

const recoverPassword = async (data) => {
    console.log(data);
    try {
        const response = await axios.put(RECOVER_URL,
                data,
                { headers: { 'Content-Type': 'application/json' } }
            );
        return response?.data;
    } catch (error) {
       throw new Error(error.response.data.error);
    }
};


const resetPassword = async (data, _id) => {
    try {
        const response = await axios.put(`${RESET_URL}/${_id}`,
                data,
            );
        return response?.data;
    } catch (error) {
       throw new Error(error.response.data.error);
    }
};

const refreshToken= async()=>{
    try {
        const response = await axiosPrivate.get(REFRESH_URL);
        return response?.data?.accessToken;
    } catch (error) {
       throw new Error(error.response.data.error);
    }
}

const AuthService={
    register,
    login,
    recoverPassword,
    resetPassword,
    refreshToken
}

export default AuthService;





